import React from "react"

import "./section.scss"
import { TIMINGS, ANIMATION } from "../config/animation"

const Section = ({
  title,
  children,
  image,
  reverse,
  border,
  padded,
  noparagraph,
  theme,
}) => {
  return (
    <section
      className={`section-padding col2 centre section ${theme ? theme : ""} ${
        reverse ? "section--reverse" : ""
      }`}
    >
      <div
        className="col-large"
        data-sal={ANIMATION.effect}
        data-sal-delay={TIMINGS.fast}
        data-sal-easing={ANIMATION.ease}
        data-sal-duration={ANIMATION.duration}
      >
        {title ? <h2>{title}</h2> : ""}
        {title ? <hr /> : ""}
        {noparagraph ? children : <p>{children}</p>}
      </div>
      <div
        className={`col-image ${border && "col-image--border"} ${
          padded && "col-image--padded"
        }`}
      >
        {/* <Centre> */}
        <img
          src={image}
          alt=""
          data-sal={ANIMATION.effect}
          data-sal-delay={TIMINGS.medium}
          data-sal-easing={ANIMATION.ease}
          data-sal-duration={ANIMATION.duration}
        />
        {/* </Centre> */}
      </div>
    </section>
  )
}

export default Section
